/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { V3BreakerCollageComponent } from '../v3-breaker-collage/code-split/v3-breaker-collage-component';
import { V3BreakerGalleryModuleComponent } from '../v3-breaker-gallery-module/code-split/v3-breaker-gallery-module-component';
import { V3BreakerRichCarouselModuleComponent } from '../v3-breaker-rich-carousel-module/code-split/v3-breaker-rich-carousel-module-component';

const V3BreakerImages: React.FC<ComponentLayoutType<any>> = (props) => {

  const { data:{moduleStyle}} = props;

  const imageModuleMapper = () => {
    switch (moduleStyle) {
      case 'Collage':
        return <V3BreakerCollageComponent />;
      case 'Gallery':
        return <V3BreakerGalleryModuleComponent />;
      case 'Carousel':
        return <V3BreakerRichCarouselModuleComponent />;
      default:
        return null;
    }
  
  }

  return (
    <ComponentLayout {...props}>           
      {imageModuleMapper()}
    </ComponentLayout>
  );
};

export default V3BreakerImages;
